<dx-form class="form" id="form" [(formData)]="selectedRow">
  <dxi-item
    [label]="{ text: 'Belge Kodu' }"
    dataField="BelgeKod"
    [validationRules]="validationRulesMap['BelgeKod']"
    [editorOptions]="{ readOnly: true }"
  >
  </dxi-item>

  <dxi-item
    dataField="KullaniciEh"
    [label]="{ text: 'Kullanıcı E/H?' }"
    [validationRules]="validationRulesMap['KullaniciEh']"
  >
    <div *dxTemplate>
      <dk-ct-gen-radio-btn
        [lookUpType]="'GEN_EVETHAYIR'"
        [dataField]="'AktifEh'"
        [value]="selectedRow?.KullaniciEh"
        (valueChange)="selectedRow.KullaniciEh = $event"
        [validationRules]="validationRulesMap['KullaniciEh']"
      ></dk-ct-gen-radio-btn>
    </div>
  </dxi-item>

  <dxi-item
    dataField="Note"
    [label]="{ text: 'Not' }"
    [validationRules]="validationRulesMap['Note']"
    editorType="dxTextArea"
  ></dxi-item>
</dx-form>
<dx-toolbar class="bottomSaveCancelBtn">
  <dxi-item location="after">
    <dx-button
      stylingMode="contained"
      type="danger"
      text="İptal"
      (onClick)="handleCancelClick()"
    ></dx-button>
  </dxi-item>
  <dxi-item location="after">
    <dx-button
      stylingMode="contained"
      type="default"
      text="Kaydet"
      (onClick)="handleSaveClick()"
      [disabled]="isLoading"
    ></dx-button>
  </dxi-item>
</dx-toolbar>
